<section class="list" [hidden]="isEmpty">
  @if (list$ | async; as data) {
    <div class="list__heading">
      @if (!onGetConfig.hideTitle) {
        <h3 class="list__title" [innerHTML]="onGetConfig?.title | translate | ignoreHtmlTags | safe: 'html'"></h3>
      }
    </div>
    <div class="game-grid" [ngClass]="{tournament: onGetConfig?.type === 'tournament'}">
      @for (game of data?.gameList; track $index) {
        <app-game-preview class="game-grid__item" [game]="game"></app-game-preview>
      }
      @if (showMore) {
        <div class="game-grid__item" (click)="goToRoute()">
          <div class="card-gradient">
            <div class="link__text">
              <div fittext [minFontSize]="10" [maxFontSize]="16">
                {{'t.all' | translate}}<br>
                <div [innerHTML]="onGetConfig?.title | translate | safe: 'html'"></div>
              </div>
            </div>
            <div class="link">
              <i class="icon-arrow"></i>
            </div>
          </div>
        </div>
      }
    </div>
  } @else {
    <div class="list__heading">
      <div class="list__title"><app-skeleton [count]="1" [animation]="'progress'"></app-skeleton></div>
    </div>
    <div class="game-grid">
      <app-skeleton [count]="1" [animation]="'progress'" [type]="'block'"></app-skeleton>
      <app-skeleton [count]="1" [animation]="'progress'" [type]="'block'"></app-skeleton>
      <app-skeleton [count]="1" [animation]="'progress'" [type]="'block'"></app-skeleton>
      <app-skeleton [count]="1" [animation]="'progress'" [type]="'block'"></app-skeleton>
      <app-skeleton [count]="1" [animation]="'progress'" [type]="'block'"></app-skeleton>
      <app-skeleton [count]="1" [animation]="'progress'" [type]="'block'"></app-skeleton>
    </div>
  }
</section>

